import { render, staticRenderFns } from "./VModalHeader.vue?vue&type=template&id=43994e18&scoped=true&functional=true&"
import script from "./VModalHeader.vue?vue&type=script&lang=js&"
export * from "./VModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "43994e18",
  null
  
)

export default component.exports